<template>
  <modal name="news" height="auto" width="550px" :scrollable="true">
    <div class="news">
      <div class="close">
        <img class="hover_btn" src="../../assets/icons/close.svg" @click="$modal.hide('news')"  alt="">
      </div>
      <div class="title">{{news.title}}</div>
      <div class="info mt-1"><div class="author" :class="{admin: news.admin}">{{'Администрация'+','}}</div> {{news.time}}</div>
      <div class="text mt-1" >{{news.description}}</div>
    </div>
  </modal>
</template>

<script>

export default {
  name: "news-modal",
  props:{
  },
  data: ()=>({
    news:{}
  }),
  methods: {
    open(news){
      this.news = news;
      this.$modal.show('news')
    },
  }
}
</script>
<style>
  .vm--modal{
    background-color: white !important;
  }
</style>
<style scoped lang="scss">
.news{
  padding: 20px;
  .close{
    margin-right: -10px;
    margin-top: -15px;
  }
  .title{
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 19px;
    color: #2D3137;
    margin-bottom: 10px;
  }
  .info {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 13px;
    line-height: 15px;
    color: #636974;
    margin-bottom: 10px;

    .author {
      margin-right: 5px;

      &.admin {
        color: #2CB181;
      }
    }
  }
  .text {
    font-weight: normal;
    font-size: 14px;
    line-height: 21px;
    color: #2D3137;
  }
}
</style>
